export const STORAGE_KEY = 'otpCooldowns';
export const DURATION_SECONDS = 30 * 60;
